import { FIELD_PATHS, PII_FIELD_MASKING_CLASS } from '@funnels/constants';
import { CompanyEntityIndex } from '@funnels/types';

import { TextInputField } from '../../Fields';

interface BusinessNameProps extends CompanyEntityIndex {
  label?: string;
  isOptional?: boolean;
  isDisabled?: boolean;
}

export const BusinessName = (props: BusinessNameProps) => {
  const { label = 'Business name', companyIndex, ...rest } = props;

  return (
    <TextInputField
      {...rest}
      name={FIELD_PATHS.COMPANY_BUSINESS_NAME(companyIndex)}
      label={label}
      validationFailMessage={`Please enter the ${label.toLowerCase()}`}
      className={PII_FIELD_MASKING_CLASS}
    />
  );
};
